export default __webpack_public_path__ + "static/media/header_cart.9a5ad269.svg";